//change the url as per QA/ trainig or Live respectively

// export const BASE_URL_CULINARYSUITE = "https://questqa.digitalcd.in:65000/";
// export const BASE_URL_CULINARYSUITE = "https://rittraining.culinarysuite.com/"
// export const BASE_URL_CULINARYSUITE =  "https://ritlive.culinarysuite.com/"


// export const URL_CONFIG = "https://urlconfiguration-trainingms.culinarysuite.com/"
// export const TENANT_SEARCH_NEW = `${URL_CONFIG}api/URLConfigration/SearchNew`;

export const TENANT_SEARCH_NEW = () => {
  return `${localStorage.getItem("config-api")}api/URLConfigration/SearchNew`;
}

export const TENANT_SEARCH_NEW_FOR_SHIBBO = `${process.env.REACT_APP_URL_CONFIG}api/URLConfigration/SearchNew`; 

export const ApiUrls = () => {
  let url = localStorage.getItem("base-url");
  return {
    SERVICE_TOKEN:
      `${url}api/serviceToken/detail`,

    AUTHENTICATION_REQUEST: `${url}api/user/AuthenticationRequest`,

    GET_ROLE_BASED_FEATUREACCESS: `${url}api/featureaccess/SearchRolebasedFeatureAccess`,
    GET_ALL_NOTIFICATION: `${url}api/notifications/search`,
    GET_FISCAL_WEEK: `${url}api/calendar/searchInventoryFiscalWeek`,
    GET_INVENTORY_STORAGE: `${url}api/InventoryStorage/search`,
    GET_LOCATION: `${url}api/inventoryCheck/Search`,
    SEARCH_PRODUCT_BY_UPCCODE: `${url}api/product/SearchProductByUPCCode`,
    ACCOUNT_BY_CURRENT_USER: `${url}api/account/SearchAccountsByCurrentUser`,
    PROCESSCODE_BY_FLASK_API: `https://barcode-fulcrumoneflask.demo.fulcrumone.net/processCode`,
    PRICING_BY_PRODUCT: `${url}api/vendorproductpricing/searchPricingByProduct`,
    INVENTORY_CHECK_DETAIL: `${url}api/InventoryCheck/detail`,
    INVENTORY_CHECK_PRODUCT: `${url}api/inventoryCheckProduct/search`,
    UPDATE_INVENTORY: `${url}api/inventoryCheckProduct/UpdateInventoryUsingPWA`,    
    UPDATE_INVENTORY_FOR_OFFLINE: `${url}api/inventoryCheckProduct/updateInventory`,
    UPDATE_PRODUCT: `${url}api/InventoryCheck/update`,

    ALL_PRODUCTS: `${url}api/inventoryCheckProduct/search`,
    OFFLINE_INVENTORY_CHECK: `${url}api/InventoryCheck/SearchOfflineInventoryCheck`,
    OFFLINE_PRICE: `${url}api/VendorProductPricing/SearchProductPricingForOfflineInventoryAPI`,
    OFFLINE_PREVIOUS_QUANTITY: `${url}api/product/SearchProductPreviousQuantityDeatil`,
    SEARCH_PRODUCT_BY_UPCCODE_OFFLINE: `${url}api/product/SearchProductUPCCodeDeatil`,
    PRODUCT_STORAGE_DETAILS_OFFLINE: `${url}api/product/SearchProductStorageDeatil`,
    //  GET_INVENTORY_STORAGE_OFFLINE : `${url}api/locationstoragearea/search`,
    GET_INVENTORY_STORAGE_OFFLINE: `${url}api/InventoryStorage/search`,
    GET_LOCATION_OFFLINE: `${url}api/location/search`,

    CONFIG_DATA_SEARCH: `${url}api/MedataConfigurationReader/configMetadataListSearch`,

    //Account Wise Inventory
    GET_ACCOUNTS: `${url}api/physicalInventorycheck/search`,
    INVENTORY_COUNT: `${url}api/inventoryCount/search`,
    GET_LOCATION_DETAILS: `${url}api/ambassador/UserwiseAccountLocationSearch`,
    UPDATE_ACCOUNT_INVENTORY: `${url}api/inventoryCount/createWithAccountPWA`,
    UPDATE_ACCOUNT_INVENTORY_FOR_OFFLINE: `${url}api/inventoryCount/createWithAccount`,
    INVENTORY_POST_TO_VALIDATE: `${url}api/InventoryProductInventoriesValidate/InventoryPostToGPValidate`,
    PRODUCT_BY_INVENTORY_COUNT: `${url}api/product/ProductSearchByInventoryAccount`,
    PHYSICAL_INVENTORYCHECK_OFFLINE: `${url}api/physicalInventorycheck/SearchPhysicalInventorycheckForOffline`,

    // Server Logger
    UPDATE_LOGS: `${url}api/product/UpdatePWALogs`,

    //inmate scan
    SERVE_TIME_OFFLINE: `${url}api/mealServeTime/ServeTimeSearchForOffline`,
    INMATE_DETAIL: `${url}api/patient/InmateDetail`,
    INMATE_SCANNING_ORDER: `${url}api/takeOrder/inmateScanningOrder`,
    INMATE_ORDER_DETAIL: `${url}api/patient/InmateOrderDetail`,
    SEARCH_ROLE_BASED_MENU: `${url}api/applicationmenuaccess/SearchRoleBasedMenu`
  }
}

// export const SERVICE_TOKEN =
//   `${BASE_URL_CULINARYSUITE}api/serviceToken/detail`;

// export const AUTHENTICATION_REQUEST = `${BASE_URL_CULINARYSUITE}api/user/AuthenticationRequest`;

// export const GET_ROLE_BASED_FEATUREACCESS = `${BASE_URL_CULINARYSUITE}api/featureaccess/SearchRolebasedFeatureAccess`;
// export const GET_ALL_NOTIFICATION = `${BASE_URL_CULINARYSUITE}api/notifications/search`;
// export const GET_FISCAL_WEEK = `${BASE_URL_CULINARYSUITE}api/calendar/searchInventoryFiscalWeek`;
// export const GET_INVENTORY_STORAGE = `${BASE_URL_CULINARYSUITE}api/InventoryStorage/search`;
// export const GET_LOCATION = `${BASE_URL_CULINARYSUITE}api/inventoryCheck/Search`;
// export const SEARCH_PRODUCT_BY_UPCCODE = `${BASE_URL_CULINARYSUITE}api/product/SearchProductByUPCCode`;
// export const ACCOUNT_BY_CURRENT_USER = `${BASE_URL_CULINARYSUITE}api/account/SearchAccountsByCurrentUser`;
// export const PROCESSCODE_BY_FLASK_API = `https://barcode-fulcrumoneflask.demo.fulcrumone.net/processCode`;
// export const PRICING_BY_PRODUCT = `${BASE_URL_CULINARYSUITE}api/vendorproductpricing/searchPricingByProduct`;
// export const INVENTORY_CHECK_DETAIL = `${BASE_URL_CULINARYSUITE}api/InventoryCheck/detail`;
// export const INVENTORY_CHECK_PRODUCT = `${BASE_URL_CULINARYSUITE}api/inventoryCheckProduct/search`;
// export const UPDATE_INVENTORY = `${BASE_URL_CULINARYSUITE}api/inventoryCheckProduct/updateInventory`;
// export const UPDATE_PRODUCT = `${BASE_URL_CULINARYSUITE}api/InventoryCheck/update`

// export const ALL_PRODUCTS = `${BASE_URL_CULINARYSUITE}api/inventoryCheckProduct/search`
// export const OFFLINE_INVENTORY_CHECK = `${BASE_URL_CULINARYSUITE}api/InventoryCheck/SearchOfflineInventoryCheck`
// export const OFFLINE_PRICE = `${BASE_URL_CULINARYSUITE}api/VendorProductPricing/SearchProductPricingForOfflineInventoryAPI`
// export const OFFLINE_PREVIOUS_QUANTITY = `${BASE_URL_CULINARYSUITE}api/product/SearchProductPreviousQuantityDeatil`
// export const SEARCH_PRODUCT_BY_UPCCODE_OFFLINE = `${BASE_URL_CULINARYSUITE}api/product/SearchProductUPCCodeDeatil`;
// export const PRODUCT_STORAGE_DETAILS_OFFLINE = `${BASE_URL_CULINARYSUITE}api/product/SearchProductStorageDeatil`;
// // export const GET_INVENTORY_STORAGE_OFFLINE = `${BASE_URL_CULINARYSUITE}api/locationstoragearea/search`;
// export const GET_INVENTORY_STORAGE_OFFLINE = `${BASE_URL_CULINARYSUITE}api/InventoryStorage/search`;
// export const GET_LOCATION_OFFLINE = `${BASE_URL_CULINARYSUITE}api/location/search`;

// export const GET_UPDATED_VERSION = `${BASE_URL_CULINARYSUITE}api/MedataConfigurationReader/configMetadataListSearch`;

// //Account Wise Inventory
// export const GET_ACCOUNTS = `${BASE_URL_CULINARYSUITE}api/physicalInventorycheck/search`;
// export const INVENTORY_COUNT = `${BASE_URL_CULINARYSUITE}api/inventoryCount/search`;
// export const GET_LOCATION_DETAILS = `${BASE_URL_CULINARYSUITE}api/ambassador/UserwiseAccountLocationSearch`;
// export const UPDATE_ACCOUNT_INVENTORY = `${BASE_URL_CULINARYSUITE}api/inventoryCount/createWithAccount`;
// export const INVENTORY_POST_TO_VALIDATE = `${BASE_URL_CULINARYSUITE}api/InventoryProductInventoriesValidate/InventoryPostToGPValidate`;
// export const PRODUCT_BY_INVENTORY_COUNT = `${BASE_URL_CULINARYSUITE}api/product/ProductSearchByInventoryAccount`;
// export const PHYSICAL_INVENTORYCHECK_OFFLINE = `${BASE_URL_CULINARYSUITE}api/physicalInventorycheck/SearchPhysicalInventorycheckForOffline`;
